<div class="auth-form">
  <div class="mt-150">
    <span class="title title--big">Восстановление доступа</span>
  </div>
  <div class="mt-32">
    <form [formGroup]="recoveryForm" (submit)="onSubmitRecoveryForm()">
      <div class="color-blue-dark">
        Для восстановления пароля введите<br />
        e-mail, указанный при регистрации вашего аккаунта.
      </div>
      <div class="mt-16">
        <app-field>
          <label>E-mail</label>
          <input
            class="input-text"
            type="email"
            formControlName="email"
            [ngClass]="{
              'input-text-validation input-text--invalid': !recoveryForm.valid && recoveryForm.value.email.length > 0
            }"
            required
            id="email"
            pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
          />
        </app-field>
      </div>
      <div class="mt-16">
        <button class="button" type="submit" [disabled]="!recoveryForm.valid" id="appRecoverySubmit">Далее</button>
      </div>
      <div class="mt-16">
        <app-message [type]="'error'" *ngIf="!recoveryForm.valid && recoveryForm.value.email.length > 0">
          <div message-content>Некорректный формат e-mail</div>
        </app-message>
      </div>
    </form>
    <div class="mt-32">
      <a routerLink="{{ '/' + AUTH_PATHS.login }}" class="link link--gray" id="appReturnToAuth">Вернуться к авторизации</a>
    </div>
  </div>
  <div class="mt-16" *ngIf="recoveryError">
    <app-message [type]="'error'">
      <div message-content>{{ recoveryError }}</div>
    </app-message>
  </div>
</div>
